import { classnames } from 'Utils/classnames/classnames.utils';
import React, { Children } from 'react';
import Markdown from 'react-markdown';
import RemarkBreaks from 'remark-breaks';
import { HTML_ELEMENTS, markdownRootHeadingRenderer } from 'Components/utils/markdown/markdown';
import { themes } from './Heading.themes';
const MARKDOWN_ALLOWED_TYPES = [
  HTML_ELEMENTS.BREAK.type,
  HTML_ELEMENTS.EMPHASIS.type,
  HTML_ELEMENTS.PARAGRAPH.type,
  HTML_ELEMENTS.STRONG.type,
  HTML_ELEMENTS.TEXT.type,
];
type Props = {
  children: Node;
  className?: string;
  color?: Colors;
  hLevel?: number;
  theme?: keyof typeof themes;
};

const HeadingText = ({ children }) => children;

export const Heading = ({
  children,
  className,
  hLevel = 1,
  theme = 'heading-brand-1',
  ...rest
}: Props) => {
  if (!Children.count(children)) {
    return null;
  }

  const { thRoot } = themes[theme];
  return (
    <Markdown
      allowedTypes={MARKDOWN_ALLOWED_TYPES}
      className={classnames(thRoot, className)}
      plugins={[RemarkBreaks]}
      renderers={{
        root: markdownRootHeadingRenderer({ ...rest, hLevel }),
        paragraph: HeadingText,
      }}
    >
      {children}
    </Markdown>
  );
};
